// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__27V8L","content":"RecentSearches_content__38Cd6"};